module.exports = __webpack_public_path__ + "img/s00176.4adbe092.png";